<template>
  <div class="message-mini-program">
    <div class="message-mini-program__title">{{ title }}</div>
    <div class="message-mini-program__cover" :style="coverStyle"></div>
    <div class="message-mini-program__footer">
      <i class="icon-infinity-line t-iconfont"></i>
      <span>小程序</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      title: '',
      url: ''
    })
  }
})

const title = computed(() => props.message.title || '')
const coverStyle = computed(() => ({
  backgroundImage: props.message.url ? `url(${props.message.url})` : 'none'
}))
</script>

<style lang="scss" scoped>
.message-mini-program {
  box-sizing: border-box;
  width: 248px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #f2f3f5;
  border-radius: 8px;
}

.message-mini-program__title {
  padding: 12px 12px 0;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-mini-program__cover {
  // width: 100%;
  height: 168px;
  margin: 12px 12px 0;
  background-color: #f7f8fa;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  // border-radius: 4px;
}

.message-mini-program__footer {
  display: flex;
  align-items: center;
  height: 24px;
  padding: 0 12px;
  margin-top: 12px;
  font-size: 12px;
  line-height: 24px;
  border-top: 1px solid #f2f3f5;

  .t-iconfont {
    font-size: 16px;
    line-height: 16px;
    color: #6f7bfb;
    transform: rotate(-45deg);
  }

  span {
    margin-left: 4px;
    font-size: 12px;
    color: #969799;
  }
}
</style>
